module.exports = __webpack_public_path__ + "img/newlogo.1124c741.png";